import React from 'react';
import loadable from '@loadable/component';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Loader } from '../../../../common/components';
// Routes
const ListInterviewStatusPage = loadable(() => import('./ListInterviewStatusPage'), {
  fallback: <Loader />
});
const AddInterviewStatusPage = loadable(() => import('./AddInterviewStatusPage'), {
  fallback: <Loader />
});
const EditInterviewStatusPage = loadable(() => import('./EditInterviewStatusPage'), {
  fallback: <Loader />
});
const InterviewStatusRoute = ({ t, alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListInterviewStatusPage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddInterviewStatusPage t={t} alert={alert} />} />
      <Route exact path="/edit/:id" element={<EditInterviewStatusPage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
InterviewStatusRoute.propTypes = {
  t: PropTypes.func
};
export default InterviewStatusRoute;
